import api from './api';
import { cache } from '../utils/cache';

export interface LoginResponse {
  token: string;
  user: {
    id: string;
    email: string;
    full_name: string;
    role: string;
    company_id: string;
    email_notifications_enabled: boolean;
  };
  company: {
    id: string;
    name: string;
    code: string;
    address: string;
    email?: string;
    phone?: string;
    website?: string;
    currency_symbol?: string;
  };
  permissions?: Array<{ obj: string; act: string }>;
  company_can_edit_roles?: boolean;
  mcp_api_key?: string;
}

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>('/auth/login', { email, password });
    return response.data;
  },
  
  register: async (data: Record<string, unknown>) => {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  checkEmail: async (email: string) => {
    const response = await api.post('/auth/check-email', { email });
    return response.data;
  },

  validateVoucher: async (code: string) => {
    const response = await api.post<{ valid: boolean; name: string; duration_months: number }>(
      '/auth/validate-voucher',
      { code },
    );
    return response.data;
  },

  requestOtp: async (email: string) => {
    const response = await api.post('/auth/request-otp', { email });
    return response.data;
  },

  verifyOtp: async (email: string, otp: string) => {
    const response = await api.post('/auth/verify-otp', { email, otp });
    return response.data;
  },

  forgotPassword: async (email: string) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token: string, newPassword: string) => {
    const response = await api.post('/auth/reset-password', { token, new_password: newPassword });
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  getMe: async () => {
    return cache.fetch('auth_me', async () => {
      const response = await api.get('/auth/me');
      return response.data;
    });
  }
};
